"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      fontSize: theme.typography.caption.fontSize,
      color: theme.palette.darkGrey.light,
      marginBottom: theme.spacing(1),
      display: 'block'
    },
    error: {
      color: theme.palette.red.main
    },
    success: {
      color: theme.palette.green.main
    }
  };
});
var Label = function Label(props) {
  var classes = useStyles();
  var label = props.label,
    inputId = props.inputId,
    required = props.required,
    error = props.error,
    success = props.success;
  return !!label && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    component: "label",
    variant: "body1",
    htmlFor: inputId,
    className: (0, _clsx["default"])(classes.root, error && classes.error, !error && success && classes.success)
  }, required ? "".concat(label, "*") : label);
};
Label.propTypes = {
  label: _propTypes["default"].string.isRequired,
  inputId: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  success: _propTypes["default"].bool
};
Label.defaultProps = {
  inputId: undefined,
  required: false,
  error: false,
  success: false
};
var _default = exports["default"] = Label;